import { render, staticRenderFns } from "./mainDialogFile.vue?vue&type=template&id=15aa4347&scoped=true&"
import script from "./mainDialogFile.vue?vue&type=script&lang=js&"
export * from "./mainDialogFile.vue?vue&type=script&lang=js&"
import style0 from "./mainDialogFile.vue?vue&type=style&index=0&id=15aa4347&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aa4347",
  null
  
)

export default component.exports